import {
    FormControl,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
    FormControlLabel,
    Switch
} from "@mui/material";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import adapterLocale from 'date-fns/locale/hu';
import {DatePicker} from "@mui/x-date-pickers";
import {useContext, useState} from "react";
import ApartmentContext from "../../context/ApartmentContext";

const FeaturedPeriodData = ({reference, obj}) => {
    const {apartments} = useContext(ApartmentContext);

    const [startDate, setStartDate] = useState(obj?.start_date || new Date());
    const [endDate, setEndDate] = useState(obj?.end_date || new Date());
    const [apartment, setApartment] = useState(obj?.apartment || 1);

    // instead of boolean, use string: "amount" or "percent"
    const [discountType, setDiscountType] = useState(
        obj?.discount_type || (obj?.is_minus ? "amount" : "percent")
    );

    const [amount, setAmount] = useState(obj?.minus || "");
    const [percent, setPercent] = useState(obj?.percent || "");

    const toggleDiscountType = (checked) => {
        const newType = checked ? "amount" : "percent";
        setDiscountType(newType);

        if (newType === "amount") {
            setPercent("");
        } else {
            setAmount("");
        }
    };

    return (
        <form ref={reference}>
            <Stack spacing={2}>

                {/* Name */}
                <Typography variant='caption'>Neve</Typography>
                <TextField
                    variant='standard'
                    id="name"
                    name="name"
                    defaultValue={obj?.name || ''}
                />

                {/* Switch between "amount" and "percent" */}
                <FormControlLabel
                    control={
                        <Switch
                            checked={discountType === "amount"}
                            onChange={(e) => toggleDiscountType(e.target.checked)}
                            name="discount_type"
                        />
                    }
                    label={discountType === "amount" ? "Összeg" : "Százalék"}
                />

                {/* Amount field */}
                {discountType === "amount" && (
                    <>
                        <Typography variant='caption'>Összeg</Typography>
                        <TextField
                            variant='standard'
                            id="minus"
                            name="minus"
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </>
                )}

                {/* Percent field */}
                {discountType === "percent" && (
                    <>
                        <Typography variant='caption'>Százalék (%)</Typography>
                        <TextField
                            variant='standard'
                            id="percent"
                            name="percent"
                            type="number"
                            value={percent}
                            onChange={(e) => setPercent(e.target.value)}
                        />
                    </>
                )}

                {/* Min days */}
                <Typography variant='caption'>Minimum foglalható napok száma</Typography>
                <TextField
                    variant='standard'
                    id="min_days"
                    name="min_days"
                    type='number'
                    defaultValue={obj?.min_days || 1}
                />

                {/* Start date */}
                <Typography variant='caption'>Kezdete</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale}>
                    <DatePicker
                        value={startDate}
                        inputFormat="yyyy-MM-dd"
                        mask="____-__-__"
                        onChange={(newValue) => setStartDate(newValue)}
                        renderInput={(params) =>
                            <TextField variant='standard' id="start_date" name="start_date" {...params} />
                        }
                    />
                </LocalizationProvider>

                {/* End date */}
                <Typography variant='caption'>Vége</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale}>
                    <DatePicker
                        value={endDate}
                        inputFormat="yyyy-MM-dd"
                        mask="____-__-__"
                        onChange={(newValue) => setEndDate(newValue)}
                        renderInput={(params) =>
                            <TextField variant='standard' id="end_date" name="end_date" {...params} />
                        }
                    />
                </LocalizationProvider>

                {/* Apartment */}
                <Typography variant='caption'>Ház</Typography>
                <FormControl fullWidth>
                    <Select
                        id="apartment-select"
                        variant='standard'
                        name='apartment'
                        value={apartment}
                        onChange={e => setApartment(e.target.value)}
                    >
                        {apartments?.map(a =>
                            <MenuItem key={a?.id} value={a?.id}>{a?.name}</MenuItem>
                        )}
                    </Select>
                </FormControl>

                {/* Hidden field to submit the discount type */}
                <input type="hidden" name="discount_type" value={discountType}/>

            </Stack>
        </form>
    );
};

export default FeaturedPeriodData;
